module.exports = __webpack_public_path__ + "img/City_network-1024x187.87f2645f.png";